import { CouponData } from "./CouponType";
import { fetchAsyncCoupon } from "./CouponSlice";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { TimeConverter } from "../../utils/TimeConverter";
import { DateConverter } from "../../utils/DateConverter";

interface CouponValidProps {
  data: CouponData[];
}

const CouponValid: React.FC<CouponValidProps> = ({ data }) => {
  return (
    <>
      {data &&
        data.map((item) => (
          <tr key={item.coupon_name} className="coupon_item_container">
            <td className="valid_coupon_all_item">{item.coupon_name}</td>
            <td className="valid_coupon_all_item">{item.coupon_info}</td>
            <td className="valid_coupon_all_item">
              {item.coupon_discount}
              {item.coupon_type}
              引き
            </td>
            <td className="valid_coupon_all_item">{item.get_limit}</td>
            <td className="valid_coupon_all_item">{item.get_count}</td>
            <td className="valid_coupon_all_item">
              {DateConverter(item.start_date)}
            </td>
            <td className="valid_coupon_all_item">
              {DateConverter(item.expiry)}
            </td>
            <td className="valid_coupon_all_item">{item.is_reusable}</td>
            <td className="valid_coupon_all_item">{item.is_single_use}</td>
            <td className="valid_coupon_all_item">{item.is_weekend}</td>
            {/* <td className="valid_coupon_all_item">{item.time_limit}</td> */}
            <td className="valid_coupon_all_item">
              {item.available_start_time === "なし"
                ? "なし"
                : TimeConverter(item.available_start_time, {
                    timezone: "Asia/Tokyo",
                  })}
            </td>
            <td className="valid_coupon_all_item">
              {item.available_end_time === "なし"
                ? "なし"
                : TimeConverter(item.available_end_time, {
                    timezone: "Asia/Tokyo",
                  })}
            </td>
          </tr>
        ))}
    </>
  );
};

export default CouponValid;
